import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Game from "@/pages/Game";
import Leaderboard from "@/pages/Leaderboard";
import Profile from "@/pages/Profile";
import { PlayerProvider } from "@/context/PlayerContext";
import "@/App.css";

function App() {
  return (
    <PlayerProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-center" richColors closeButton />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/play" element={<Game />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </PlayerProvider>
  );
}

export default App;
